module.exports = __webpack_public_path__ + "static/media/jersey.dd26db27.jpg";